let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cgQIg")).then(() => parcelRequire('7Hi0z'));